<template>
	<div>
		<paginated-search
			v-bind="{ schema, searchEntities, openEntity, createEntity, syncEntity, importEntity: false, autoEnable: true }"
			@show="showModal = true"></paginated-search>
		<import-modal :description="importDescription" v-if="showModal" v-bind="{ name, uploadResource }"
			@close="showModal = false"></import-modal>
		<modal v-if="showResultModal" @close="showResultModal = false" :modalWidth="700" :modalMaxWidth="50">
			<template slot="header">
				<span class="title" style="font-size: large;">Resultado da Importação</span>
			</template>
			<template slot="body">
				<!-- exibir listagem dos resultados -->
				<div style="max-height: 450px; overflow-y: auto;">
					<table>
						<tr v-for="company in companies">
							<td class="centralizar-icone"
								:style="{ color: company.Status == 'A' ? '#448aff' : (company.Status == 'I' ? 'green' : 'red'), fontSize: 'large' }">
								&#10687;
							</td>
							<td>
								{{ company.RazaoSocial }}
							</td>
							<td>{{ company.Codigo }}</td>
							<td>{{ company.IDSAP }}</td>
						</tr>
						<tr v-for="company in inactives">
							<td class="centralizar-icone" style="color: red;">
								&#10687;
							</td>
							<td>
								{{ company.RazaoSocial }}
							</td>
							<td>{{ company.Codigo }}</td>
							<td>{{ company.IDSAP ? company.IDSAP : '' }}</td>
							<td></td>
						</tr>
					</table>
				</div>
			</template>
			<template slot="footer">
				<md-button class="md-accent" @click="copy()" style="margin: 5px">Copiar</md-button>
				<md-button class="md-accent" @click="saveFile()" style="margin: 5px">Baixar JSON</md-button>
				<md-button class="md-danger" @click="showResultModal = false">Fechar</md-button>
			</template>
		</modal>
	</div>
</template>

<script>
import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
import ImportModal from "@/components/Espresso/ImportModal.vue";
import Company from "@/models/company.model.vue";
import EspressoAux from "@/components/Espresso/EspressoAux.vue";
import { Modal } from "@/components";

export default {
	components: {
		PaginatedSearch,
		ImportModal,
		Modal,
	},
	data() {
		return {
			schema: Company.getSchema(),
			showModal: false,
			showResultModal: false,
			companies: [],
			inactives: [],
			companiesResponse: {},
			name: "Importar empresas a partir de CSV",
			importDescription: "Formato do CSV: Nome; Link do Logo; Código URL; Senha padrão",
		};
	},
	methods: {
		openEntity(entity) {
			this.$router.push(`/empresa/${entity.id}`);
		},
		createEntity() {
			this.$router.push(`/empresa/novo`);
		},
		searchEntities(paginationParameters) {
			return Company.search(paginationParameters);
		},
		uploadResource(csv) {
			return Company.importCsv(csv);
		},
		async syncEntity() {
			//Company.syncCompanies();
			const { value } = await EspressoAux.showLoadingModal(Company.syncCompanies(), "Processando...", "", "Não foi possível atualizar as empresas.");
			console.log('ap-sync', value);
			this.companiesResponse = value;

			if (value) {
				this.companies = [];
				//juntar as subcompanies
				value.Empresas.forEach((emp) => {
					this.companies.push(emp);
					if (emp.SubEmpresas) {
						emp.SubEmpresas.forEach((sub) => {
							sub.RazaoSocial = ` -  ${sub.RazaoSocial}`;
							this.companies.push(sub);
						});
					}
				});
				console.log(this.companies);
				this.inactives = [...value.EmpresasInativadas];
				this.showResultModal = true;
			}
			return value;
			// const result = await Company.syncCompanies();
			// console.log('sap-sync', result);
			// return true;
		},
		copy() {
			var linhas = [];
			linhas.push("Status;Razão Social;0800;ID SAP");
			if (this.companies) {
				this.companies.forEach(c => {
					linhas.push(`${c.Status == "A" ? "ATUALIZADO" : (c.Status == "I" ? "INSERIDO" : "ERRO")};${c.RazaoSocial};${c.Codigo};${c.IDSAP}`);
				})
			}
			if (this.inactives) {
				this.inactives.forEach(c => {
					linhas.push(`INATIVO;${c.RazaoSocial};${c.Codigo};${c.IDSAP ? c.IDSAP : ''}`);
				})
			}
			if (linhas.length > 0) {
				navigator.clipboard.writeText(linhas.join("\n"));
			}
		},
		async saveFile() {
			if (!this.companiesResponse) {
				return;
			}
			try {
				const handle = await window.showSaveFilePicker({
					suggestedName: 'companies.json',
					types: [{
						description: 'Arquivos JSON',
						accept: { 'text/json': ['.json'] },
					}],
				});
				const writableStream = await handle.createWritable();
				await writableStream.write(JSON.stringify(this.companiesResponse));
				await writableStream.close();
				console.log('File saved successfully!');
			} catch (error) {
				console.error('Error saving file:', error);
			}
		}
	},
}
</script>

<style>
.centralizar-icone {
	text-align: center !important;
	vertical-align: middle;
	align-items: center;
	width: 15px;
}
</style>
